import React from 'react';
import { useIntl } from 'react-intl';
import Translate from '@spordle/intl-elements';

import { GENDERS } from "../../lib";

import BaseEnumFilter from './BaseEnumFilter';

export default ({ name = 'gender', label = <Translate id="components.filters.gender" />, ...props }) => {
  const { formatMessage } = useIntl();
  const getOptionLabel = gender => formatMessage({ id: `common.enums.genders.${gender}` });

  return <BaseEnumFilter name={name} label={label} options={GENDERS} getOptionLabel={getOptionLabel} {...props} />
}
